import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import {
  useActiveAllocateShippingUnit,
  useInactiveAllocateShippingUnit,
  useListAllocateShippingUnit,
  useListCustomer,
  useListTransport,
} from "hooks";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { setListAllocateShippingUnitColumn } from "store/actions";
import {
  allocateShippingRecordStatus,
  allocateShippingRecordStatusMode,
  allocateShippingUnitMode,
  getInitAllocateShippingUnitParams,
} from "./utils";
import Select from "react-select";
import AllocateShippingUnitsDetailOrCreate from "./AllocateShippingUnitsDetailOrCreate.js";
import { Link, useNavigate } from "react-router-dom";
import ConfirmModal from "components/shared-components/ConfirmModal";
import { getInitCustomerParams } from "pages/CustomerManagement/utils";
import BadgeForTable from "components/shared-components/BadgeForTable";

const ListAllocateShippingUnits = () => {
  const { t, i18n } = useTranslation(["allocateShippingUnits"]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const allocateShippingUnits = useSelector(
    state => state.allocateShippingUnits
  );

  const {
    list: { columnsVisible: allocateShippingUnitColumnsVisible },
  } = allocateShippingUnits;

  /* ================================== START INIT STATE ==================================== */

  const [columnsTable, setColumnsTable] = useState([]);
  const [transportFilter, setTransportFilter] = useState(null);
  const [transports, setTransports] = useState([]);
  const [allocateShippingUnitId, setAllocateShippingUnitId] = useState(null);
  const [detailModal, setDetailModal] = useState(false);
  const [mode, setMode] = useState("");
  const [inActiveModal, setInactiveModal] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [allocateShippingUnitParams, setAllocateShippingUnitParams] = useState(
    getInitAllocateShippingUnitParams
  );
 
  const [transportParams, setTransportParams] = useState(
    getInitAllocateShippingUnitParams
  );

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  // TRANSPORT LIST

  const onFetchTransportsSuccess = response => {
    const list = response?.items || [];
    const result = [];

    list.forEach(item => {
      result.push({ label: item.name, value: item.id });
    });

    setTransports(result);

    setAllocateShippingUnitParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      run: true,
    }));
  };

  const { isFetching: isLoadingTransport, refetch: fetchTransports } =
    useListTransport(
      {
        params: {
          ...getInitAllocateShippingUnitParams,
          columnFilter: { "filter[record_status]": "O" },
        },
      },
      onFetchTransportsSuccess
    );

  // INACTIVE

  const onInactiveAllocateShippingUnitSuccess = () => {
    fetchAllocateShippingUnits();
  };

  const { mutate: inActiveAllocateShippingUnit } =
    useInactiveAllocateShippingUnit(onInactiveAllocateShippingUnitSuccess);

  // ACTIVE

  const onActiveAllocateShippingUnitSuccess = () => {
    fetchAllocateShippingUnits();
  };

  const { mutate: activeAllocateShippingUnit } = useActiveAllocateShippingUnit(
    onActiveAllocateShippingUnitSuccess
  );

  // ALLOCATE SHIPPING UNIT LIST

  const {
    isFetching: isLoadingList,
    data: allocateShippingList,
    refetch: fetchAllocateShippingUnits,
  } = useListAllocateShippingUnit({ params: allocateShippingUnitParams });

  useEffect(() => {
    if (allocateShippingUnitParams && allocateShippingUnitParams.run) {
      fetchAllocateShippingUnits();
    }
  }, [allocateShippingUnitParams]);

  useEffect(() => {
    if (transportParams && transportParams.run) {
      fetchTransports();
    }
  }, [transportParams]);

  useEffect(() => {
    setTransportParams(prev => ({
      ...prev,
      page: -1,
      run: true,
    }));

    initColumn();
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [transports, transportParams]);

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const initColumn = () => {
    if (
      allocateShippingUnitColumnsVisible &&
      Object.keys(allocateShippingUnitColumnsVisible).length > 0
    ) {
      initColumns.forEach(item => {
        if (allocateShippingUnitColumnsVisible[item.dataField] !== undefined) {
          item.hidden = !allocateShippingUnitColumnsVisible[item.dataField];
        }
      });
    }
    setColumnsTable(initColumns);
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setAllocateShippingUnitParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : allocateShippingUnitParams.sort,
      columnFilter: columnFilter || {},
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));

    setTransportParams(prev => ({
      ...prev,
      columnFilter: columnFilter || {},
      run: false,
    }));
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "record_status":
        if (prefix === "allocate_shipping_units") {
          options = allocateShippingRecordStatus;
        }
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    options.forEach(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "record_status":
        if (prefix === "allocate_shipping_units") {
          options = allocateShippingRecordStatus;
        }
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {selectOptionsTable(cell, name, prefix)}
          </BadgeForTable>
        )
    );
  };

  const onSearchAllHandle = value => {
    setAllocateShippingUnitParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListAllocateShippingUnitColumn(field, value));
    initColumn();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {},
  };

  const toggleInactiveModal = () => {
    setInactiveModal(!inActiveModal);
  };

  const toggleActiveModal = () => {
    setActiveModal(!activeModal);
  };

  const inActiveSingleHandler = () => {
    inActiveAllocateShippingUnit({
      allocateShippingUnitId,
      data: { record_status: "C" },
    });
    toggleInactiveModal();
  };

  const activeSingleHandler = () => {
    activeAllocateShippingUnit({
      allocateShippingUnitId,
      data: { record_status: "O" },
    });
    toggleActiveModal();
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const listRowAction = [
    {
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.update.allocate_shipping_units"),
      onClick: row => {
        setAllocateShippingUnitId(row.id);
        setMode(allocateShippingUnitMode.UPDATE_ALLOCATE_SHIPPING_UNIT_MODE);
        toggleDetailModal();
      },
    },
    {
      icon: <i className="fas fa-lock fa-lg text-danger" />,
      text: t("table.actions.delete.allocate_shipping_units"),
      onClick: row => {
        setAllocateShippingUnitId(row.id);
        toggleInactiveModal();
      },
      conditionVisible: {
        record_status: [allocateShippingRecordStatusMode.ACTIVE],
      },
    },
    {
      icon: <i className="fas fa-lock-open fa-lg text-success" />,
      text: t("table.actions.active.allocate_shipping_units"),
      onClick: row => {
        setAllocateShippingUnitId(row.id);
        toggleActiveModal();
      },
      conditionVisible: {
        record_status: [allocateShippingRecordStatusMode.INACTIVE],
      },
    },
  ];

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "customer.code",
      text: t("table.customer_code"),
      sort: false,
      allowExport: true,
    },
    {
      dataField: "customer_id",
      text: t("table.customer_name"),
      formatter: (cell, row) => {
        return <span>{row?.customer?.name}</span>;
      },
      sort: false,
      allowExport: true,
    },
    {
      dataField: "transport_id",
      text: t("table.transport_name"),
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => {
        return (
          <div style={{ minWidth: "200px", fontWeight: "normal" }}>
            <Select
              isClearable
              placeholder={t("common:placeholder.select")}
              options={transports}
              classNamePrefix="select2-selection"
              isLoading={isLoadingTransport}
              value={transportFilter}
              onChange={data => {
                onFilter({ data: data });
                setTransportFilter(data);
              }}
            />
          </div>
        );
      },
      formatter: (cell, row) => {
        return row?.transport?.name || "";
      },
    },
    {
      dataField: "record_status",
      text: t("table.record_status.allocate_shipping_units.name"),
      sort: true,
      align: "center",
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.record_status.allocate_shipping_units.name"),
        }),
        options: selectOptionsTable(
          undefined,
          "record_status",
          "allocate_shipping_units"
        ),
      }),
      formatter: (cell, row) => {
        if (
          cell &&
          allocateShippingRecordStatus.some(item => item.key === cell)
        ) {
          return formatOptionsTable(
            cell,
            "record_status",
            "allocate_shipping_units"
          );
        } else {
          return "";
        }
      },
      allowExport: true,
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      hidden: false,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={allocateShippingUnitParams.columnFilter}
        />
      ),
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={
              t("title.list") + ` (${allocateShippingList?.totalCount || 0})`
            }
            breadcrumbItems={[
              { name: t("title.allocate_shipping_units") },
              { name: t("title.list") },
            ]}
          />

          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Inactive Allocate Shipping Units Modal */}
              <ConfirmModal
                isOpen={inActiveModal}
                titleHeader={t("modal.allocate_shipping_units.inactive.header")}
                titleBody={t("modal.allocate_shipping_units.inactive.content")}
                onConfirm={inActiveSingleHandler}
                textBtnConfirm={t("modal.agree")}
                textBtnCancel={t("modal.cancel")}
                toggle={toggleInactiveModal}
              />
              {/* Active Allocate Shipping Units Modal */}
              <ConfirmModal
                isOpen={activeModal}
                titleHeader={t("modal.allocate_shipping_units.active.header")}
                titleBody={t("modal.allocate_shipping_units.active.content")}
                onConfirm={activeSingleHandler}
                textBtnConfirm={t("modal.agree")}
                textBtnCancel={t("modal.cancel")}
                toggle={toggleActiveModal}
              />
              {/* Detail Allocate Shipping Units Modal */}
              <AllocateShippingUnitsDetailOrCreate
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                dataDetail={{
                  allocateShippingUnitId,
                  transports,
                  fetchAllocateShippingUnits,
                }}
                mode={mode}
              />
            </Col>
            {/* Modal E N D*/}
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {columnsTable.length > 0 && (
                    <RemoteDataTable
                      // selectRow={selectRowCheckbox}
                      keyField="id"
                      data={allocateShippingList?.items || []}
                      columns={columnsTable}
                      page={allocateShippingUnitParams.page}
                      sizePerPage={allocateShippingUnitParams.sizePerPage}
                      totalSize={allocateShippingList?.totalCount || 0}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandler}
                      rowEvents={rowEventsHandler}
                      listMultipleRowAction={listMultipleRowAction}
                      listRowAction={listRowAction}
                      loading={isLoadingList}
                    >
                      <Button
                        onClick={() => {
                          setMode(
                            allocateShippingUnitMode.CREATE_ALLOCATE_SHIPPING_UNIT_MODE
                          );
                          toggleDetailModal();
                        }}
                        color="primary"
                        className="btn-label me-2"
                        type="button"
                      >
                        <i className="fas fa-plus label-icon" />
                        {t("title.create")}
                      </Button>
                      <Button
                        onClick={() => {
                          navigate(
                            { pathname: "/import-management/import" },
                            { state: { isFocusTransport: true, code: 40 } }
                          );
                        }}
                        color="primary"
                        className="btn-label"
                        type="button"
                      >
                        <i className="fas fa-file-upload me-2 label-icon" />
                        {t("title.import")}
                      </Button>
                    </RemoteDataTable>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListAllocateShippingUnits;
